import { useState } from 'react';
import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchBatchItems } from '../api/importService';
import { ImportBatchItemStatus } from '../types/api';
var PAGE_SIZE = 100;
/**
 * Hook for import batch detail — fetches failed items with offset pagination.
 * An error is reported as an error and an empty page as empty (CZNA-1344: this used to
 * fall back to invented mock rows, so a real import's detail could show errors it never had).
 */
var useImportBatchDetail = function (batchId) {
    var ky = useOkapiKy();
    var _a = useState(0), offset = _a[0], setOffset = _a[1];
    var _b = useQuery(['czna-import-batch-items', batchId, offset], function () { return fetchBatchItems(ky, batchId, { status: ImportBatchItemStatus.FAILED, offset: offset, limit: PAGE_SIZE }); }, { keepPreviousData: true, enabled: !!batchId }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError, error = _b.error;
    return {
        items: (data === null || data === void 0 ? void 0 : data.items) || [],
        totalRecords: (data === null || data === void 0 ? void 0 : data.totalRecords) || 0,
        isLoading: isLoading,
        isError: isError,
        error: error,
        offset: offset,
        setOffset: setOffset,
        pageSize: PAGE_SIZE,
    };
};
export default useImportBatchDetail;
